module.exports = __webpack_public_path__ + "static/img/far4.c081e28b.png";